module.exports = __webpack_public_path__ + "img/woodenDoor.21a28725.jpg";